import { render, staticRenderFns } from "./report-outcome.vue?vue&type=template&id=6212588e&"
import script from "./report-outcome.vue?vue&type=script&lang=js&"
export * from "./report-outcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports